module.exports = __webpack_public_path__ + "media/images/about-logo-sw-64ba8b5e51a359ab3717d25efb339986.png";